export const projectData = [
    {
        id: 1,
        column: 1,
        shortName: "shoestring",
        name: "The Shoestring Traveller",
        description: "Travel website featuring articles on amazing destinations around the world.",
        about: "This travel website features articles about the Shoestring Traveller's adventures around the world. It includes some budget travel tips and numerous breathtaking photos. The app also allows users to log in and comment on their favourite articles.",
        technologies: ["React", "Node.js", "Express.js", "MongoDB"],
        demo: "https://www.youtube.com/watch?v=0gZP3fPHipo&t=326s&ab_channel=MatthewLangmuir",
        github: "https://github.com/mlangmuir/the-shoestring-traveller",
    },
    {
        id: 2,
        column: 1,
        shortName: "slingair",
        name: "slingAir",
        description: "Airline ticket booker concept.",
        about: "This ticket booking app allows users to book one of eight flights from Canadian cities to Honolulu. For each booking, the availability of the seats gets updated and recorded in the database so no seat gets booked twice!",
        technologies: ["React", "Node.js", "Express.js", "MongoDB"],
        demo: "https://www.youtube.com/watch?v=iyu7ZcsxeZs&ab_channel=MatthewLangmuir",
        github: "https://github.com/mlangmuir/slingair-ticket-booker",
    },
    {
        id: 3,
        column: 1,
        shortName: "nyan-cats",
        name: "Raining Nyan Cats",
        description: "JavaScript browser game.",
        about: "A browser game based on the Internet meme Nyan Cat. The game involves the user using the left and right arrow keys to move a burger and try to avoid the cats that are raining down from the top of the screen.",
        technologies: ["JavaScript", "HTML", "CSS"],
        website: "https://rainingnyancats.matthewlangmuir.com/",
        github: "https://github.com/mlangmuir/raining-nyan-cats-game",
    },
    {
        id: 4,
        column: 2,
        shortName: "shopfit",
        name: "Shopfit",
        description: "E-commerce website concept.",
        about: "This full-stack application allows users to browse through 348 different electronic gadgets. The site features a search bar and allows users to filter products based on price, category, body location and availability.",
        technologies: ["React", "Node.js", "Express.js", "MongoDB"],
        demo: "https://www.youtube.com/watch?v=fYlcX2Ul3h0&t=1s&ab_channel=MatthewLangmuir",
        github: "https://github.com/mlangmuir/shopfit-e-commerce",
    },
    {
        id: 5,
        column: 2,
        shortName: "facespace",
        name: "Facespace",
        description: "Social networking application concept.",
        about: "This is a social networking application with a simple sign-in function. It uses session storage to keep the user logged in while they are using the application.",
        technologies: ["React", "Node.js", "Express.js"],
        demo: "https://www.youtube.com/watch?v=NvgMKt3NJ0c&ab_channel=MatthewLangmuir",
        github: "https://github.com/mlangmuir/facespace",
    },
    {
        id: 6,
        column: 2,
        shortName: "critter",
        name: "Critter",
        description: "Cat-themed Twitter website concept.",
        about: "This React application allows user to send tweets (or meows) and navigate to the profiles of different cats.",
        technologies: ["React"],
        demo: "https://www.youtube.com/watch?v=H6wl6lcQYi8&ab_channel=MatthewLangmuir",
        github: "https://github.com/mlangmuir/critter-cat-twitter-clone",
    },
]